import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import Separator from '../../../core/layout/Separator';
import TextInput from '../../../core/form/TextInput';
import TimeInput from '../../../core/form/TimeInput';
import FormButtons from '../../../core/form/FormButtons';
import Select from '../../../core/form/Select';

const MasteryTestForm = (props) => (
  <form
    onSubmit={(event) => {
      event.preventDefault();
      props.onSubmit();
    }}
  >
    <Row>
      <Column size={2}>
        <Select
          required
          options={['A', 'B', 'C', 'D'].map((value) => ({
            value,
            label: value,
          }))}
          disabled={props.submitting || props.disabled}
          label="Group"
          value={get(props.values, 'group', '')}
          onChange={(value) => props.onChange('group', value)}
          errorText={get(props.errors, 'group', '')}
        />
      </Column>
      {props.values.id && (
        <Column size={3}>
          <TimeInput disabled label="Deadline Time" value={props.deadlineTime} />
        </Column>
      )}
      <Column size={3}>
        <TextInput label="Score to Pass" disabled value="70" />
      </Column>
    </Row>
    <Separator size="md" />
    <FormButtons
      confirmLabel={props.values.id ? 'Update Mastery Test' : 'Create Mastery Test'}
      isDisabled={props.submitting || !props.isDirty()}
      isSubmitting={props.submitting}
      onReset={props.onReset}
    />
  </form>
);

MasteryTestForm.propTypes = {
  deadlineTime: PropTypes.number.isRequired,
  onSubmit: PropTypes.func,
  onReset: PropTypes.func,
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  isDirty: PropTypes.func,
};

MasteryTestForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  isDirty: () => false,
  onSubmit: () => alert('submitted'),
  onReset: () => false,
};

export default MasteryTestForm;
